import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["details", "toggle"];
  static values = {
    url: String,
    loaded: Boolean,
  };

  toggle() {
    if (this.detailsTarget.classList.contains("d-none")) {
      this.show();
    } else {
      this.hide();
    }
  }

  show() {
    this.detailsTarget.classList.remove("d-none");
    this.toggleTarget.textContent = "Hide scores";

    if (!this.loadedValue) {
      this.loadScores();
    }
  }

  hide() {
    this.detailsTarget.classList.add("d-none");
    this.toggleTarget.textContent = "Show scores";
  }

  async loadScores() {
    this.detailsTarget.textContent = "Loading scores...";

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
      });

      if (!response.ok) {
        throw new Error(`HTTP error ${response.status}`);
      }

      const data = await response.json();
      if (data.error) {
        throw new Error(data.error);
      }

      if (!data.scores || data.scores.length === 0) {
        this.detailsTarget.textContent = "No scores available.";
        this.loadedValue = true;
        return;
      }

      const lines = data.scores.map(
        (score) => `${score.name}: ${score.display}`
      );
      this.detailsTarget.innerHTML = lines.join("<br>");
      this.loadedValue = true;
    } catch (error) {
      console.error("Error loading scores:", error);
      this.detailsTarget.textContent = "Unable to load scores.";
    }
  }
}
